import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const StatementOnTheUseOfCookies = (props) => {
  return (
    <div
      style={{
        padding: '2rem 8%',
        textAlign: 'left',
        minHeight: 'calc(100vh - 200px)',
        // color: "#FFFFFF",
      }}
    >
      <Typography variant={'h1'}>STATEMENT ON THE USE OF COOKIES</Typography>
      We, Mercedes-Benz AG, use cookies and similar software tools such as HTML5
      Storage or Local Shared Objects (together "cookies") that are technically
      necessary to provide this website to you, including all of its functions
      and services that you use.
      <br />
      <br />
      <Typography variant={'h6'}>1. Functions and use of cookies</Typography>
      <br />
      a. Cookies are small files that are placed on your desktop, notebook or
      mobile device by a website you visit. From this we can, for example,
      manage your selections in the online vehicle configurator, maintain your
      log-in status or manage your shopping cart (as relevant). Cookies may also
      contain personal data (such as a pseudonymous sequence of characters
      identifying your browsing session). <br />
      <br />
      b. You can also visit our website without the use of cookies. This means
      that you can reject and delete cookies at any time by making the
      appropriate settings on your device. This is done as follows:{' '}
      <ul>
        i. Most browsers are pre-set to automatically accept cookies. You can
        change this setting by activating the setting *do not accept cookies* in
        your browser.
      </ul>
      <ul>
        ii. You can delete existing cookies at any time. You can find out how
        this works in detail in the instructions of your browser or device
        manufacturer.
      </ul>{' '}
      <ul>
        iii. Like the use of cookies, their rejection or deletion is also linked
        to the device used and also to the browser used in each case. You must
        therefore reject or delete the cookies separately for each of your
        devices and, if you use several browsers, also for each browser.
      </ul>{' '}
      c. If you decide against the use of cookies, it is possible that not all
      functions and services of our websites are available to you or that
      individual functions or services are only available to you to a limited
      extent.
      <br />
      <br />
      <Typography variant={'h6'}>2. List of cookies</Typography>
      <br />
      On this website, only cookies that are technically necessary for its
      operation are used.
      <br />
      <br />
      <Typography variant={'h6'}>3. Additional information</Typography>
      <br />
      For more information regarding data protection on our website, please
      refer to the{' '}
      <Link
        to='/dpnotice'
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        Data Protection Notice
      </Link>
      . <br />
      <br />
      E-Mail:{' '}
      <a
        href='mailto:obl-management@mercedes-benz.com'
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        obl-management@mercedes-benz.com
      </a>
    </div>
  );
};

export { StatementOnTheUseOfCookies };
